<template>
  <a-modal
    title="新建要货通知单"
    :width="900"
    :visible="visible"
    :maskClosable="false"
    okText="保存并发布"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div>
    <a-table
      :columns="columns"
      :data-source="tableList"
      :pagination="false"
      row-key="indexId"
      :scroll="{ x: 800, y: 260 }"
    >
      <span slot="mainBodyCodeTitle">
        <i class="toRequired">*</i>主体
      </span>
      <span slot="organizationCodeTitle">
        <i class="toRequired">*</i>加工组织
      </span>
      <span slot="itemIdTitle">
        <i class="toRequired">*</i>物料编码
      </span>
      <span slot="uomTitle">
        <i class="toRequired">*</i>单位
      </span>
      <span slot="supplierIdTitle">
        <i class="toRequired">*</i>供应商
      </span>
      <span slot="needByDateTitle">
        <i class="toRequired">*</i>要求到货日期
      </span>
      <span slot="quantityTitle">
        <i class="toRequired">*</i>需求数量
      </span>
      <span slot="subinventoryTitle">
        <i class="toRequired">*</i>目的仓
      </span>
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record">
        <div :key="item.dataIndex">
          <span v-if="item.dataIndex === 'operation'">
            <a @click="handleDelete(tableList, record)">删除</a>
          </span>
          <span v-else-if="item.type === 'select'">
            <global-select
              :disabled="item.disabled || false"
              :value.sync="record[item.dataIndex]"
              :selectType="item.selectType ? item.selectType : 'select'"
              :focusGet="item.focusGet ? item.focusGet : false"
              :requestApi="item.requestApi"
              :selectData="setArray(item.dataList)"
              :selectItem="{ value: item.value, label: item.label, thirdLabel: item.thirdLabel }"
              :searchParam="item.searchParam ? item.searchParam : ''"
              :setParams="item.setParams ? setParamsHandle(record, item.dataIndex) : null"
              :allowClear="false"
              :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
              :sourseField="item.sourseField ? item.sourseField : ''"
              :dropdown-match-select-width="item.dropdownMatchSelectWidth === false ? false : true"
              :getOnlyDataSelect="item.getOnlyDataSelect ? item.getOnlyDataSelect : false"
              :defaultSelect="item.defaultSelect ? setDefaultSelect(record, item.dataIndex, item) : null"
              @change="(val, list) => selectChange(val, list, record, item.dataIndex)"
            />
          </span>
          <span v-else-if="item.type === 'date'">
            <a-date-picker v-model="record[item.dataIndex]" valueFormat="YYYY-MM-DD" />
          </span>
          <span v-else-if="item.type === 'input'">
            <a-input v-model="record[item.dataIndex]" :disabled="item.disabled" />
          </span>
          <span v-else-if="item.type === 'inputNumber'">
            <a-input-number v-model="record[item.dataIndex]" :min="0" />
          </span>
        </div>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiGetSubInvByItem,
  apiPoDeliveryNoticeLinesAddList,
  apiPoGetMainBodyCombobox
} from '@/api/scp/reserve-goods-plan/for-goods-manage'

export default {
  props: {
    inventOrg: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      mainBodyList: [], // 公司主体下拉数据
      columns: [
        {
          // title: '主体',
          dataIndex: 'mainBodyCode',
          scopedSlots: { customRender: 'mainBodyCode', title: "mainBodyCodeTitle" },
          width: 150,
          type: "select",
          selectType: "selectFilter",
          dataList: 'mainBodyList',
          value: 'realValue',
          label: 'label',
          getOnlyDataSelect: true
        },
        {
          // title: '加工组织',
          dataIndex: 'organizationCode',
          scopedSlots: { customRender: 'organizationCode', title: "organizationCodeTitle" },
          width: 180,
          type: "select",
          selectType: "selectAssemble",
          assembleLabel: true,
          dataList: 'inventOrg',
          value: 'realValue',
          label: 'label',
          dropdownMatchSelectWidth: false
        },
        {
          // title: '物料编码',
          dataIndex: 'itemId',
          scopedSlots: { customRender: 'itemId', title: "itemIdTitle" },
          width: 150,
          type: "select",
          selectType: "selectSearch",
          requestApi: "/mdm/mdmItemOrganizationItem/itemCodeOneBox",
          value: 'realValue',
          label: 'label',
          setParams: true,
          searchParam: "itemCode",
          getOnlyDataSelect: true
        },
        {
          // title: '单位',
          dataIndex: 'uom',
          scopedSlots: { customRender: 'uom', title: "uomTitle" },
          width: 150,
          type: "input",
          disabled: true
        },
        {
          title: '物料名称',
          dataIndex: 'bringOutDataTwo',
          scopedSlots: { customRender: 'bringOutDataTwo' },
          width: 150,
          type: "input",
          disabled: true
        },
        {
          title: '规格描述',
          dataIndex: 'bringOutDataThree',
          scopedSlots: { customRender: 'bringOutDataThree' },
          width: 150,
          type: "input",
          disabled: true
        },
        {
          title: 'MPQ',
          dataIndex: 'bringOutDataFour',
          scopedSlots: { customRender: 'bringOutDataFour' },
          width: 150,
          type: "input",
          disabled: true
        },
        {
          // title: '供应商',
          dataIndex: 'supplierId',
          scopedSlots: { customRender: 'supplierId', title: "supplierIdTitle" },
          width: 150,
          type: "select",
          selectType: "selectSearch",
          requestApi: "/mdm/mdmOrgSupplier/supplierBox",
          value: 'realValue',
          label: 'label',
          thirdLabel: "selectedValue",
          searchParam: "supplierName",
          getOnlyDataSelect: true
        },
        {
          // title: '要求到货日期',
          dataIndex: 'requestDeliveryDate',
          scopedSlots: { customRender: 'requestDeliveryDate', title: "needByDateTitle" },
          width: 150,
          type: "date"
        },
        {
          // title: '需求数量',
          dataIndex: 'quantity',
          scopedSlots: { customRender: 'quantity', title: "quantityTitle" },
          width: 150,
          type: "inputNumber"
        },
        {
          // title: '目的仓',
          dataIndex: 'subinventory',
          scopedSlots: { customRender: 'subinventory', title: "subinventoryTitle" },
          width: 160,
          // type: "select",
          // requestApi: "/po/poDeliveryNoticeLines/subinventoryBox",
          // value: 'realValue',
          // label: 'label',
          // setParams: true,
          disabled: true,
          // defaultSelect: false
          type: "input"
        },
        {
          title: '备注',
          dataIndex: 'comments',
          scopedSlots: { customRender: 'comments' },
          width: 160,
          type: "input"
        },
        {
          title: '操作',
          width: 60,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      tableList: []
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {},
  methods: {
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show () {
      this.initGetMainBody()
      this.addLine()
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.tableList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        mainBodyCode: "", // 主体
        organizationCode: this.organizationCodeOrigin,
        itemId: "",
        uom: "",
        bringOutDataTwo: "",
        bringOutDataThree: "",
        bringOutDataFour: "",
        supplierId: "",
        requestDeliveryDate: "",
        quantity: "",
        subinventory: "",
        comments: "",
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.tableList = arr
    },
    // 初始化加载主体数据
    initGetMainBody() {
      this.mainBodyList = []
      this.confirmLoading = true
      apiPoGetMainBodyCombobox({}).then(res => {
        if (res?.code === 200 && res?.data?.length > 0) {
          this.mainBodyList = res.data
        }
      }).finally(e => {
        this.confirmLoading = false
      })
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.tableList.length; i++) {
        if (!this.tableList[i].mainBodyCode || !this.tableList[i].organizationCode || !this.tableList[i].itemId || !this.tableList[i].uom || !this.tableList[i].supplierId || !this.tableList[i].requestDeliveryDate || !this.tableList[i].subinventory) {
          this.$message.warning('必填项不能为空')
          flag = true
          return
        }
        if (!this.tableList[i].quantity) {
          this.$message.warning('需求数量 需大于0')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      apiPoDeliveryNoticeLinesAddList(this.tableList).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success', response.data)
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.tableList = []
    },
    // 根据物料查找目的仓
    searchSubinventory(record) {
      record.subinventory = ''
      if(record.itemCode && record.mainBodyCode) {
        apiGetSubInvByItem({ itemCode: record.itemCode, mainBodyCode: record.mainBodyCode }).then(res => {
          if (res?.code === 200) {
            record.subinventory = res?.data?.length > 0 ? res?.data[0]?.realValue : ""
          }
        })
      }
    },
    selectChange (val, list, record, dataIndex) {
      if (dataIndex === "itemId") {
        record.uom = this.$getFlagName(list, val, "realValue", "bringOutDataOne")
        record.bringOutDataTwo = this.$getFlagName(list, val, "realValue", "bringOutDataTwo")
        record.bringOutDataThree = this.$getFlagName(list, val, "realValue", "bringOutDataThree")
        record.bringOutDataFour = this.$getFlagName(list, val, "realValue", "bringOutDataFour")
        if (val) {
          const getItem = list?.find(item => item.realValue === val)
          if(getItem?.label) { record.itemCode = getItem.label } // 记录itemCode为前端临时用，用于查目的仓
          this.searchSubinventory(record) // 查询目的仓
        } else {
          record.subinventory = ""
        }
      } else if(dataIndex === "mainBodyCode") {
        this.searchSubinventory(record) // 查询目的仓
      }
      // if (dataIndex === "supplierId") {
      //   record.subinventory = ""
      // }
    },
    setParamsHandle (record, dataIndex) {
      if (dataIndex === "itemId") {
        return { organizationCode: record.organizationCode }
      }
      if (dataIndex === "subinventory") {
        return { supplierId: record.supplierId, organizationCode: record.organizationCode }
      }
    },
    setDefaultSelect (record, dataIndex) {
      if (dataIndex === "subinventory") {
        return { defaultParam: "selectedValue", defaultValue: "Y" }
      }
    },
    setArray (arr) {
      return this[arr]
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
input{
  width: 140px;
}
/deep/.ant-input-number{
  width: 140px;
}
/deep/.ant-select{
  width: 140px;
}
</style>
